import { HtmlParser } from '@angular/compiler';

export class Quiz {
  id: any;
  quizname: string;
  json:string;
  quiztitledesc:string;
  ispublished:number;
  length: number;
  startdate: any;
enddate: any;
createddate: Date;
createdby: any;
Isedit: number;
_id: any;
totolrows: number;
studentrestriction: number;
  }

  export class Assignmentedit {
    id: number;
    Astitle : string;
    Elp:string;
    filesize:string;
    filsizetype : string
    filecount:number;
    score:number;
    ckeditor : HtmlParser;
    ispublished:number;
  }
  
  